import {ProtocolQuery} from '../../../service-model/protocol-query.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

/**
 * @returns StrategyCommanderRuleDto[]
 */
export class GetAvailableCommanderRules implements ProtocolQuery {
  constructor(public readonly terminals: string[]) {
  }

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetAvailableCommanderRules`;
  }
}
